import { render, staticRenderFns } from "./ReceiptViewer.vue?vue&type=template&id=3aa97a8a"
import script from "./ReceiptViewer.vue?vue&type=script&lang=js"
export * from "./ReceiptViewer.vue?vue&type=script&lang=js"
import style0 from "./ReceiptViewer.vue?vue&type=style&index=0&id=3aa97a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports